import React, { useEffect, useMemo, useState, Fragment } from 'react';
import { TrendingUp, Clock, BarChart3, Wallet, CreditCard, Plus, AlertCircle, ArrowDownToLine, Search, ChevronDown, ChevronUp, Download, X, CheckCircle2, FileText, ArrowUpRight, ArrowDownRight, RefreshCcw, Percent, Crown, Megaphone, Receipt, PiggyBank, ArrowRight, ArrowLeft, Shield, Loader2, Check, Smartphone } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import { Input } from '../ui/Input';
import { Pagination } from '../ui/Pagination';
interface FinancesTabProps {
  showToast: (msg: string) => void;
  setActiveTab?: (tab: string) => void;
}
type TxType = 'income' | 'withdrawal' | 'refund' | 'commission' | 'subscription' | 'advertising';
type TxStatus = 'completed' | 'pending' | 'failed';
interface Transaction {
  id: string;
  date: string;
  type: TxType;
  description: string;
  amount: number;
  status: TxStatus;
  orderId?: string;
  clientName?: string;
  serviceName?: string;
  commissionPercent?: number;
  commissionAmount?: number;
  netAmount?: number;
  source?: string;
}
interface PaymentMethod {
  id: string;
  type: 'card' | 'crypto' | 'paypal';
  name: string;
  details: string;
  isDefault: boolean;
}
const MOCK_TRANSACTIONS: Transaction[] = [{
  id: 'tx-sub-3',
  date: '2024-10-15T00:01:00',
  type: 'subscription',
  description: 'Подписка PRO — Октябрь',
  amount: -990,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-ad-2',
  date: '2024-10-14T18:00:00',
  type: 'advertising',
  description: 'Реклама: Баннер в каталоге',
  amount: -1500,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-1042',
  date: '2024-10-15T14:30:00',
  type: 'income',
  description: 'Оплата заказа #1042',
  amount: 5000,
  status: 'completed',
  orderId: 'ORD-1042',
  clientName: 'Елена Смирнова',
  serviceName: 'Натальная карта',
  commissionPercent: 15,
  commissionAmount: 750,
  netAmount: 4250
}, {
  id: 'tx-1041',
  date: '2024-10-14T11:15:00',
  type: 'income',
  description: 'Оплата заказа #1041',
  amount: 6000,
  status: 'completed',
  orderId: 'ORD-1041',
  clientName: 'Дмитрий В.',
  serviceName: 'Синастрия',
  commissionPercent: 15,
  commissionAmount: 900,
  netAmount: 5100
}, {
  id: 'tx-w1',
  date: '2024-10-10T09:00:00',
  type: 'withdrawal',
  description: 'Вывод средств на карту *4276',
  amount: -32000,
  status: 'completed',
  commissionPercent: 0,
  commissionAmount: 0,
  netAmount: -32000
}, {
  id: 'tx-ad-1',
  date: '2024-10-05T12:00:00',
  type: 'advertising',
  description: 'Реклама: Закрепление в категории',
  amount: -2000,
  status: 'completed',
  source: 'balance'
}, {
  id: 'tx-sub-2',
  date: '2024-09-15T00:01:00',
  type: 'subscription',
  description: 'Подписка PRO — Сентябрь',
  amount: -990,
  status: 'completed',
  source: 'card'
}, {
  id: 'tx-1030',
  date: '2024-10-01T16:45:00',
  type: 'income',
  description: 'Оплата заказа #1030',
  amount: 5000,
  status: 'completed',
  orderId: 'ORD-1030',
  clientName: 'Анна К.',
  serviceName: 'Натальная карта',
  commissionPercent: 15,
  commissionAmount: 750,
  netAmount: 4250
}, {
  id: 'tx-1029',
  date: '2024-09-28T20:10:00',
  type: 'income',
  description: 'Покупка товара',
  amount: 990,
  status: 'completed',
  orderId: 'ORD-1029',
  clientName: 'Иван П.',
  serviceName: 'Вебинар Меркурий',
  commissionPercent: 10,
  commissionAmount: 99,
  netAmount: 891
}, {
  id: 'tx-r1',
  date: '2024-09-20T12:00:00',
  type: 'refund',
  description: 'Возврат по заказу #1020',
  amount: -5000,
  status: 'completed',
  orderId: 'ORD-1020',
  clientName: 'Мария Л.',
  serviceName: 'Натальная карта'
}, {
  id: 'tx-w2',
  date: '2024-09-15T10:30:00',
  type: 'withdrawal',
  description: 'Вывод средств на карту *4276',
  amount: -28500,
  status: 'completed',
  commissionPercent: 0,
  commissionAmount: 0,
  netAmount: -28500
}, {
  id: 'tx-1015',
  date: '2024-09-10T15:20:00',
  type: 'income',
  description: 'Оплата заказа #1015',
  amount: 15000,
  status: 'completed',
  orderId: 'ORD-1015',
  clientName: 'Ольга В.',
  serviceName: 'Соляр на год',
  commissionPercent: 15,
  commissionAmount: 2250,
  netAmount: 12750
}, {
  id: 'tx-1043',
  date: '2024-10-16T08:00:00',
  type: 'income',
  description: 'Оплата заказа #1043',
  amount: 4500,
  status: 'pending',
  orderId: 'ORD-1043',
  clientName: 'Сергей М.',
  serviceName: 'Экспресс-консультация',
  commissionPercent: 15,
  commissionAmount: 675,
  netAmount: 3825
}, {
  id: 'tx-1044',
  date: '2024-10-16T09:30:00',
  type: 'income',
  description: 'Оплата заказа #1044',
  amount: 4500,
  status: 'pending',
  orderId: 'ORD-1044',
  clientName: 'Алина Т.',
  serviceName: 'Экспресс-консультация',
  commissionPercent: 15,
  commissionAmount: 675,
  netAmount: 3825
}];
const MOCK_METHODS: PaymentMethod[] = [{
  id: 'pm-1',
  type: 'card',
  name: 'Сбербанк',
  details: 'Visa •••• 4276',
  isDefault: true
}];
const SERVICES_INCOME = [{
  name: 'Натальная карта',
  amount: 210000,
  percent: 100,
  color: 'bg-indigo-500'
}, {
  name: 'Соляр на год',
  amount: 112000,
  percent: 53,
  color: 'bg-indigo-400'
}, {
  name: 'Синастрия',
  amount: 90000,
  percent: 43,
  color: 'bg-indigo-300'
}, {
  name: 'Товары',
  amount: 44550,
  percent: 21,
  color: 'bg-indigo-200'
}];
export function FinancesTab({
  showToast,
  setActiveTab
}: FinancesTabProps) {
  // State
  const [transactions, setTransactions] = useState<Transaction[]>(MOCK_TRANSACTIONS);
  const [methods, setMethods] = useState<PaymentMethod[]>(MOCK_METHODS);
  // Modals & Forms
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [withdrawAmount, setWithdrawAmount] = useState('');
  const [selectedMethodId, setSelectedMethodId] = useState(MOCK_METHODS[0].id);
  const [addingCard, setAddingCard] = useState(false);
  const [newCard, setNewCard] = useState({
    number: '',
    name: ''
  });
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadPeriod, setDownloadPeriod] = useState('month');
  const [downloadType, setDownloadType] = useState('all');
  // Top-up flow
  const [showTopupModal, setShowTopupModal] = useState(false);
  const [topupStep, setTopupStep] = useState(0); // 0=amount, 1=method, 2=card, 3=sms, 4=processing, 5=success
  const [topupAmount, setTopupAmount] = useState<number | null>(null);
  const [topupCustom, setTopupCustom] = useState('');
  const [topupMethod, setTopupMethod] = useState<string | null>(null);
  const [topupCardNumber, setTopupCardNumber] = useState('');
  const [topupCardExpiry, setTopupCardExpiry] = useState('');
  const [topupCardCvv, setTopupCardCvv] = useState('');
  const [topupCardName, setTopupCardName] = useState('');
  const [topupSaveCard, setTopupSaveCard] = useState(true);
  const [topupSmsCode, setTopupSmsCode] = useState('');
  const [topupSmsTimer, setTopupSmsTimer] = useState(60);
  const [topupSmsSent, setTopupSmsSent] = useState(false);
  // Filters & UI State
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterType, setFilterType] = useState<TxType | 'all'>('all');
  const [filterStatus, setFilterStatus] = useState<TxStatus | 'all'>('all');
  const [expandedTxId, setExpandedTxId] = useState<string | null>(null);
  const [showAllIncomeServices, setShowAllIncomeServices] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;
  // Unified Balance
  const mainBalance = 24500;
  const pendingAmount = 9000;
  const totalBalance = mainBalance + pendingAmount;
  const earnedThisMonth = 48000;
  const totalEarned = 324500;
  // Expenses
  const subscriptionExpense = 990;
  const advertisingExpense = 3500;
  const commissionExpense = 5325;
  const totalExpenses = subscriptionExpense + advertisingExpense + commissionExpense;
  // Ad budget
  const adBudgetBalance = 4500;
  // Derived Data
  const availableToWithdraw = 24500;
  const filteredTransactions = useMemo(() => {
    return transactions.filter(tx => {
      const matchesSearch = tx.description.toLowerCase().includes(searchQuery.toLowerCase()) || tx.orderId && tx.orderId.toLowerCase().includes(searchQuery.toLowerCase()) || tx.clientName && tx.clientName.toLowerCase().includes(searchQuery.toLowerCase());
      const matchesType = filterType === 'all' || tx.type === filterType;
      const matchesStatus = filterStatus === 'all' || tx.status === filterStatus;
      return matchesSearch && matchesType && matchesStatus;
    }).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }, [transactions, searchQuery, filterType, filterStatus]);
  // Reset page on filter change
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery, filterType, filterStatus]);
  const totalPages = Math.ceil(filteredTransactions.length / ITEMS_PER_PAGE);
  const paginatedTransactions = filteredTransactions.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);
  // Handlers
  const handleWithdraw = () => {
    const amount = parseInt(withdrawAmount.replace(/\D/g, ''), 10);
    if (isNaN(amount) || amount < 1000) {
      showToast('Минимальная сумма вывода: 1 000 ₽');
      return;
    }
    if (amount > availableToWithdraw) {
      showToast('Недостаточно средств для вывода');
      return;
    }
    const newTx: Transaction = {
      id: `tx-w-${Date.now()}`,
      date: new Date().toISOString(),
      type: 'withdrawal',
      description: `Вывод средств на ${methods.find(m => m.id === selectedMethodId)?.details}`,
      amount: -amount,
      status: 'pending',
      commissionPercent: 0,
      commissionAmount: 0,
      netAmount: -amount
    };
    setTransactions([newTx, ...transactions]);
    setShowWithdrawModal(false);
    setWithdrawAmount('');
    showToast('Заявка на вывод успешно создана');
    console.log(`[Admin Sync] Withdrawal requested: ${amount} RUB to ${selectedMethodId}`);
  };
  const handleAddCard = () => {
    if (!newCard.number || !newCard.name) {
      showToast('Заполните все поля');
      return;
    }
    const method: PaymentMethod = {
      id: `pm-${Date.now()}`,
      type: 'card',
      name: 'Новая карта',
      details: `Visa •••• ${newCard.number.slice(-4)}`,
      isDefault: false
    };
    setMethods([...methods, method]);
    setAddingCard(false);
    setNewCard({
      number: '',
      name: ''
    });
    showToast('Карта успешно добавлена');
    console.log(`[Admin Sync] New payment method added: ${method.id}`);
  };
  const handleDownload = () => {
    setShowDownloadModal(false);
    showToast('Файл выписки формируется и скоро будет скачан');
    console.log(`[Admin Sync] Statement downloaded: period=${downloadPeriod}, type=${downloadType}`);
  };
  const handleCardClick = (type: TxType | 'all', status: TxStatus | 'all' = 'all') => {
    setFilterType(type);
    setFilterStatus(status);
    setSearchQuery('');
    // Scroll to transactions
    document.getElementById('transactions-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const TOPUP_AMOUNTS_ASTRO = [3000, 5000, 10000, 20000];
  const TOPUP_METHODS = [{
    id: 'card',
    label: 'Банковская карта',
    desc: 'Visa, Mastercard, МИР',
    icon: <CreditCard className="w-5 h-5" data-id="element-12793" />
  }, {
    id: 'apple',
    label: 'Apple Pay',
    desc: 'Быстрая оплата',
    icon: <Smartphone className="w-5 h-5" data-id="element-12794" />
  }, {
    id: 'google',
    label: 'Google Pay',
    desc: 'Быстрая оплата',
    icon: <Smartphone className="w-5 h-5" data-id="element-12795" />
  }];
  const topupFinalAmount = topupAmount || parseInt(topupCustom) || 0;
  const resetTopup = () => {
    setShowTopupModal(false);
    setTopupStep(0);
    setTopupAmount(null);
    setTopupCustom('');
    setTopupMethod(null);
    setTopupCardNumber('');
    setTopupCardExpiry('');
    setTopupCardCvv('');
    setTopupCardName('');
    setTopupSmsCode('');
    setTopupSmsTimer(60);
    setTopupSmsSent(false);
  };
  const openTopup = () => {
    setShowTopupModal(true);
    setTopupStep(0);
  };
  // SMS countdown
  useEffect(() => {
    if (showTopupModal && topupStep === 3 && topupSmsTimer > 0) {
      const t = setTimeout(() => setTopupSmsTimer(v => v - 1), 1000);
      return () => clearTimeout(t);
    }
  }, [showTopupModal, topupStep, topupSmsTimer]);
  useEffect(() => {
    if (showTopupModal && topupStep === 3 && !topupSmsSent) {
      setTopupSmsSent(true);
      setTopupSmsTimer(60);
    }
  }, [showTopupModal, topupStep, topupSmsSent]);
  // Processing auto-advance
  useEffect(() => {
    if (showTopupModal && topupStep === 4) {
      const t = setTimeout(() => setTopupStep(5), 2500);
      return () => clearTimeout(t);
    }
  }, [showTopupModal, topupStep]);
  const fmtCardNum = (v: string) => {
    const d = v.replace(/\D/g, '').slice(0, 16);
    return d.replace(/(.{4})/g, '$1 ').trim();
  };
  const fmtExp = (v: string) => {
    const d = v.replace(/\D/g, '').slice(0, 4);
    return d.length > 2 ? d.slice(0, 2) + '/' + d.slice(2) : d;
  };
  const isTopupCardValid = topupCardNumber.replace(/\s/g, '').length === 16 && topupCardExpiry.length === 5 && topupCardCvv.length >= 3 && topupCardName.length >= 2;
  // Formatters
  const formatMoney = (amount: number) => {
    return new Intl.NumberFormat('ru-RU', {
      style: 'currency',
      currency: 'RUB',
      maximumFractionDigits: 0
    }).format(amount);
  };
  const formatDate = (dateStr: string) => {
    return new Intl.DateTimeFormat('ru-RU', {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    }).format(new Date(dateStr));
  };
  const getTypeConfig = (type: TxType) => {
    switch (type) {
      case 'income':
        return {
          label: 'Доход',
          color: 'text-emerald-600',
          bg: 'bg-emerald-50',
          icon: <ArrowDownRight className="w-4 h-4" data-id="element-12796" />
        };
      case 'withdrawal':
        return {
          label: 'Вывод',
          color: 'text-slate-900',
          bg: 'bg-slate-100',
          icon: <ArrowUpRight className="w-4 h-4" data-id="element-12797" />
        };
      case 'refund':
        return {
          label: 'Возврат',
          color: 'text-rose-600',
          bg: 'bg-rose-50',
          icon: <RefreshCcw className="w-4 h-4" data-id="element-12798" />
        };
      case 'commission':
        return {
          label: 'Комиссия',
          color: 'text-amber-600',
          bg: 'bg-amber-50',
          icon: <Percent className="w-4 h-4" data-id="element-12799" />
        };
      case 'subscription':
        return {
          label: 'Подписка',
          color: 'text-indigo-600',
          bg: 'bg-indigo-50',
          icon: <Crown className="w-4 h-4" data-id="element-12800" />
        };
      case 'advertising':
        return {
          label: 'Реклама',
          color: 'text-purple-600',
          bg: 'bg-purple-50',
          icon: <Megaphone className="w-4 h-4" data-id="element-12801" />
        };
    }
  };
  const getStatusBadge = (status: TxStatus) => {
    switch (status) {
      case 'completed':
        return <Badge variant="success" size="sm" data-id="element-12802">
            Выполнено
          </Badge>;
      case 'pending':
        return <Badge variant="warning" size="sm" data-id="element-12803">
            В обработке
          </Badge>;
      case 'failed':
        return <Badge variant="error" size="sm" data-id="element-12804">
            Ошибка
          </Badge>;
    }
  };
  return <div className="space-y-6 pb-20 sm:pb-0" data-id="element-12805">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2" data-id="element-12806">
        <div data-id="element-12807">
          <h2 className="text-2xl font-bold text-slate-900" data-id="element-12808">Финансы</h2>
          <p className="text-slate-500 text-sm mt-1" data-id="element-12809">
            Единый баланс · Доходы · Расходы · Выводы
          </p>
        </div>
        <Button variant="outline" icon={<ArrowDownToLine className="w-4 h-4" data-id="element-12811" />} onClick={() => setShowDownloadModal(true)} className="w-full sm:w-auto" data-id="element-12810">
          Скачать выписку
        </Button>
      </div>

      {/* Unified Balance */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4" data-id="element-12812">
        {/* Main Balance Card */}
        <Card padding="md" className="bg-slate-900 text-white border-none flex flex-col justify-between col-span-1 sm:col-span-2 lg:col-span-2 relative overflow-hidden group cursor-pointer" onClick={() => handleCardClick('all', 'completed')} data-id="element-12813">
          <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-12814">
            <Wallet className="w-16 h-16 sm:w-24 sm:h-24" data-id="element-12815" />
          </div>
          <div className="relative z-10" data-id="element-12816">
            <div className="text-slate-400 text-xs sm:text-sm mb-1 font-medium" data-id="element-12817">
              Общий баланс
            </div>
            <div className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-0.5 break-words" data-id="element-12818">
              {formatMoney(totalBalance)}
            </div>
            <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs sm:text-sm mb-3 sm:mb-4" data-id="element-12819">
              <span className="text-emerald-400 whitespace-nowrap" data-id="element-12820">
                Доступно: {formatMoney(mainBalance)}
              </span>
              <span className="text-amber-400 whitespace-nowrap" data-id="element-12821">
                В ожидании: {formatMoney(pendingAmount)}
              </span>
            </div>
            <div className="text-slate-400 text-[11px] sm:text-xs mb-3 sm:mb-4" data-id="element-12822">
              Используется для вывода, подписки и рекламы
            </div>
          </div>
          <div className="relative z-10 grid grid-cols-2 gap-2" data-id="element-12823">
            <Button variant="primary" size="md" className="bg-emerald-600 hover:bg-emerald-500 text-white border-none shadow-lg shadow-emerald-900/20 text-xs sm:text-sm whitespace-nowrap" onClick={e => {
            e.stopPropagation();
            openTopup();
          }} data-id="element-12824">
              <Plus className="w-3.5 h-3.5 mr-1 shrink-0" data-id="element-12825" /> Пополнить
            </Button>
            <Button variant="primary" size="md" className="bg-indigo-600 hover:bg-indigo-500 text-white border-none shadow-lg shadow-indigo-900/20 text-xs sm:text-sm whitespace-nowrap" onClick={e => {
            e.stopPropagation();
            setShowWithdrawModal(true);
          }} data-id="element-12826">
              Вывести
            </Button>
          </div>
        </Card>

        {/* Income this month */}
        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-indigo-300 transition-colors min-w-0 overflow-hidden" onClick={() => handleCardClick('income')} data-id="element-12827">
          <div className="min-w-0" data-id="element-12828">
            <div className="text-slate-500 text-[11px] sm:text-xs lg:text-sm mb-1 font-medium leading-tight" data-id="element-12829">
              Доход за месяц
            </div>
            <div className="text-lg sm:text-xl xl:text-2xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-12830">
              {formatMoney(earnedThisMonth)}
            </div>
          </div>
          <div className="text-[10px] sm:text-xs text-emerald-600 flex items-center font-medium bg-emerald-50 w-fit px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md" data-id="element-12831">
            <TrendingUp className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" data-id="element-12832" />{' '}
            +12%
          </div>
        </Card>

        {/* Expenses this month */}
        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-rose-300 transition-colors min-w-0 overflow-hidden" onClick={() => {
        setFilterType('all');
        setFilterStatus('all');
        document.getElementById('expenses-section')?.scrollIntoView({
          behavior: 'smooth'
        });
      }} data-id="element-12833">
          <div className="min-w-0" data-id="element-12834">
            <div className="text-slate-500 text-[11px] sm:text-xs lg:text-sm mb-1 font-medium leading-tight" data-id="element-12835">
              Расходы
            </div>
            <div className="text-lg sm:text-xl xl:text-2xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-12836">
              {formatMoney(totalExpenses)}
            </div>
          </div>
          <div className="text-[10px] sm:text-xs text-rose-600 flex items-center font-medium bg-rose-50 w-fit px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md" data-id="element-12837">
            <Receipt className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" data-id="element-12838" />{' '}
            Подписка
          </div>
        </Card>

        <Card padding="md" className="flex flex-col justify-between cursor-pointer hover:border-indigo-300 transition-colors min-w-0 overflow-hidden" onClick={() => handleCardClick('income')} data-id="element-12839">
          <div className="min-w-0" data-id="element-12840">
            <div className="text-slate-500 text-[11px] sm:text-xs lg:text-sm mb-1 font-medium leading-tight" data-id="element-12841">
              Всего
            </div>
            <div className="text-lg sm:text-xl xl:text-2xl font-bold text-slate-900 mb-2 leading-tight" data-id="element-12842">
              {formatMoney(totalEarned)}
            </div>
          </div>
          <div className="text-[10px] sm:text-xs text-indigo-600 flex items-center font-medium bg-indigo-50 w-fit px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md" data-id="element-12843">
            <BarChart3 className="w-3 h-3 sm:w-3.5 sm:h-3.5 mr-1 shrink-0" data-id="element-12844" /> За
            всё время
          </div>
        </Card>
      </div>

      {/* Expenses Breakdown */}
      <div id="expenses-section" data-id="element-12845">
        <Card padding="md" data-id="element-12846">
          <div className="flex justify-between items-center mb-4" data-id="element-12847">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-12848">
              <Receipt className="w-5 h-5 text-rose-500" data-id="element-12849" /> Расходы за месяц
            </h3>
            <span className="text-sm font-bold text-slate-900" data-id="element-12850">
              {formatMoney(totalExpenses)}
            </span>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4" data-id="element-12851">
            <div className="p-3 bg-indigo-50 rounded-xl border border-indigo-100 cursor-pointer hover:border-indigo-300 transition-colors" onClick={() => {
            setFilterType('subscription');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-12852">
              <div className="flex items-center gap-2 mb-1" data-id="element-12853">
                <Crown className="w-4 h-4 text-indigo-600" data-id="element-12854" />
                <span className="text-xs font-medium text-indigo-600" data-id="element-12855">
                  Подписка
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12856">
                {formatMoney(subscriptionExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-12857">
                PRO · списание с баланса
              </div>
            </div>
            <div className="p-3 bg-purple-50 rounded-xl border border-purple-100 cursor-pointer hover:border-purple-300 transition-colors" onClick={() => {
            setFilterType('advertising');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-12858">
              <div className="flex items-center gap-2 mb-1" data-id="element-12859">
                <Megaphone className="w-4 h-4 text-purple-600" data-id="element-12860" />
                <span className="text-xs font-medium text-purple-600" data-id="element-12861">
                  Реклама
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12862">
                {formatMoney(advertisingExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-12863">
                Баланс рекламы: {formatMoney(adBudgetBalance)}
              </div>
            </div>
            <div className="p-3 bg-amber-50 rounded-xl border border-amber-100 cursor-pointer hover:border-amber-300 transition-colors" onClick={() => {
            setFilterType('commission');
            document.getElementById('transactions-section')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} data-id="element-12864">
              <div className="flex items-center gap-2 mb-1" data-id="element-12865">
                <Percent className="w-4 h-4 text-amber-600" data-id="element-12866" />
                <span className="text-xs font-medium text-amber-600" data-id="element-12867">
                  Комиссия платформы
                </span>
              </div>
              <div className="text-lg font-bold text-slate-900" data-id="element-12868">
                {formatMoney(commissionExpense)}
              </div>
              <div className="text-[10px] text-slate-500 mt-0.5" data-id="element-12869">
                15% от заказов
              </div>
            </div>
          </div>
          <div className="bg-slate-50 rounded-lg p-3 border border-slate-100 flex items-center justify-between" data-id="element-12870">
            <div className="text-sm text-slate-600" data-id="element-12871">
              <span className="font-medium text-slate-900" data-id="element-12872">Прозрачность:</span>{' '}
              каждый заказ показывает сумму, комиссию и чистый доход
            </div>
            <ArrowRight className="w-4 h-4 text-slate-400" data-id="element-12873" />
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-12874">
        {/* Section 2: Способ вывода */}
        <Card padding="md" className="lg:col-span-2" data-id="element-12875">
          <div className="flex justify-between items-center mb-6" data-id="element-12876">
            <h3 className="font-bold text-slate-900 flex items-center gap-2" data-id="element-12877">
              <Wallet className="w-5 h-5 text-indigo-500" data-id="element-12878" /> Способ вывода
              средств
            </h3>
            {!addingCard && <Button variant="ghost" size="sm" icon={<Plus className="w-4 h-4" data-id="element-12880" />} onClick={() => setAddingCard(true)} data-id="element-12879">
                Добавить карту
              </Button>}
          </div>

          {addingCard ? <div className="bg-slate-50 border border-slate-200 rounded-xl p-5 mb-4 animate-in fade-in slide-in-from-top-2" data-id="element-12881">
              <h4 className="text-sm font-bold text-slate-900 mb-4" data-id="element-12882">
                Добавление новой карты
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-12883">
                <Input label="Номер карты" placeholder="0000 0000 0000 0000" value={newCard.number} onChange={e => setNewCard({
              ...newCard,
              number: e.target.value
            })} data-id="element-12884" />
                <Input label="Имя владельца (как на карте)" placeholder="IVAN IVANOV" value={newCard.name} onChange={e => setNewCard({
              ...newCard,
              name: e.target.value
            })} data-id="element-12885" />
              </div>
              <div className="flex gap-3 justify-end" data-id="element-12886">
                <Button variant="outline" onClick={() => setAddingCard(false)} data-id="element-12887">
                  Отмена
                </Button>
                <Button variant="primary" onClick={handleAddCard} data-id="element-12888">
                  Сохранить карту
                </Button>
              </div>
            </div> : <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4" data-id="element-12889">
              {methods.map(method => <div key={method.id} className={`border rounded-xl p-4 cursor-pointer transition-all ${selectedMethodId === method.id ? 'border-indigo-500 bg-indigo-50/30 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300 bg-white'}`} onClick={() => setSelectedMethodId(method.id)} data-id="element-12890">
                  <div className="flex items-center justify-between mb-3" data-id="element-12891">
                    <div className="flex items-center gap-3" data-id="element-12892">
                      <div className="w-10 h-10 bg-white rounded-lg shadow-sm flex items-center justify-center border border-slate-100" data-id="element-12893">
                        <CreditCard className="w-5 h-5 text-slate-700" data-id="element-12894" />
                      </div>
                      <div data-id="element-12895">
                        <div className="font-bold text-slate-900" data-id="element-12896">
                          {method.details}
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-12897">
                          {method.name}
                        </div>
                      </div>
                    </div>
                    {method.isDefault && <Badge variant="success" size="sm" data-id="element-12898">
                        Основная
                      </Badge>}
                  </div>
                  <div className="flex justify-end" data-id="element-12899">
                    <Button variant="ghost" size="sm" className="text-slate-400 hover:text-indigo-600 h-8 px-2" onClick={e => {
                e.stopPropagation();
                setAddingCard(true);
                showToast('Заполните данные новой карты');
              }} data-id="element-12900">
                      Изменить
                    </Button>
                  </div>
                </div>)}
            </div>}

          <div className="bg-slate-50 rounded-lg p-4 flex items-start gap-3 border border-slate-100" data-id="element-12901">
            <AlertCircle className="w-5 h-5 text-indigo-500 flex-shrink-0 mt-0.5" data-id="element-12902" />
            <div className="text-sm text-slate-600" data-id="element-12903">
              <p className="font-medium text-slate-900 mb-1" data-id="element-12904">
                Условия вывода средств
              </p>
              <ul className="list-disc list-inside space-y-1 text-slate-500" data-id="element-12905">
                <li data-id="element-12906">
                  Комиссия за вывод:{' '}
                  <strong className="text-slate-700" data-id="element-12907">0%</strong>
                </li>
                <li data-id="element-12908">
                  Срок зачисления:{' '}
                  <strong className="text-slate-700" data-id="element-12909">1-3 рабочих дня</strong>
                </li>
                <li data-id="element-12910">
                  Минимальная сумма вывода:{' '}
                  <strong className="text-slate-700" data-id="element-12911">1 000 ₽</strong>
                </li>
              </ul>
            </div>
          </div>
        </Card>

        {/* Section 3: Доход по услугам */}
        <Card padding="md" data-id="element-12912">
          <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-12913">
            <BarChart3 className="w-5 h-5 text-indigo-500" data-id="element-12914" /> Доход по услугам
          </h3>

          <div className="space-y-5" data-id="element-12915">
            {(showAllIncomeServices ? SERVICES_INCOME : SERVICES_INCOME.slice(0, 4)).map((item, i) => <div key={i} className="group cursor-pointer" onClick={() => {
            if (setActiveTab) setActiveTab('orders');else showToast(`Заказы: ${item.name}`);
          }} data-id="element-12916">
                <div className="flex justify-between text-sm mb-2" data-id="element-12917">
                  <span className="font-medium text-slate-700 group-hover:text-indigo-600 transition-colors" data-id="element-12918">
                    {item.name}
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-12919">
                    {formatMoney(item.amount)}
                  </span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2 overflow-hidden" data-id="element-12920">
                  <div className={`h-full rounded-full ${item.color} transition-all duration-500`} style={{
                width: `${item.percent}%`
              }} data-id="element-12921"></div>
                </div>
              </div>)}
          </div>

          {SERVICES_INCOME.length > 4 && <button onClick={() => setShowAllIncomeServices(!showAllIncomeServices)} className="w-full mt-4 text-sm font-medium text-indigo-600 hover:text-indigo-700 flex items-center justify-center gap-1 transition-colors" data-id="element-12922">
              {showAllIncomeServices ? 'Свернуть' : `Ещё ${SERVICES_INCOME.length - 4} услуг`}
            </button>}

          <Button variant="outline" fullWidth className="mt-4" onClick={() => {
          if (setActiveTab) setActiveTab('services');else showToast('Переход ко всем услугам');
        }} data-id="element-12923">
            Смотреть все услуги
          </Button>
        </Card>
      </div>

      {/* Section 4: История транзакций */}
      <Card padding="none" className="overflow-hidden" id="transactions-section" data-id="element-12924">
        <div className="p-4 sm:p-6 border-b border-slate-100" data-id="element-12925">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4" data-id="element-12926">
            <h3 className="font-bold text-slate-900 text-lg" data-id="element-12927">
              История транзакций
            </h3>

            <div className="flex w-full sm:w-auto gap-2" data-id="element-12928">
              <div className="relative flex-1 sm:w-64" data-id="element-12929">
                <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" data-id="element-12930" />
                <input type="text" placeholder="Поиск по ID или клиенту..." className="w-full pl-9 pr-4 py-2 bg-slate-50 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-all" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-12931" />
              </div>
              <Button variant={showFilters ? 'primary' : 'outline'} icon={<Search className="w-4 h-4" data-id="element-12933" />} onClick={() => setShowFilters(!showFilters)} className="shrink-0" data-id="element-12932">
                <span className="hidden sm:inline" data-id="element-12934">Фильтры</span>
              </Button>
            </div>
          </div>

          {/* Filters Panel */}
          {showFilters && <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 p-4 bg-slate-50 rounded-xl border border-slate-200 animate-in fade-in slide-in-from-top-2" data-id="element-12935">
              <div data-id="element-12936">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-12937">
                  Тип операции
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={filterType} onChange={e => setFilterType(e.target.value as TxType | 'all')} data-id="element-12938">
                  <option value="all" data-id="element-12939">Все типы</option>
                  <option value="income" data-id="element-12940">Доход</option>
                  <option value="withdrawal" data-id="element-12941">Вывод средств</option>
                  <option value="subscription" data-id="element-12942">Подписка</option>
                  <option value="advertising" data-id="element-12943">Реклама</option>
                  <option value="refund" data-id="element-12944">Возврат</option>
                  <option value="commission" data-id="element-12945">Комиссия</option>
                </select>
              </div>
              <div data-id="element-12946">
                <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-1.5" data-id="element-12947">
                  Статус
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={filterStatus} onChange={e => setFilterStatus(e.target.value as TxStatus | 'all')} data-id="element-12948">
                  <option value="all" data-id="element-12949">Все статусы</option>
                  <option value="completed" data-id="element-12950">Выполнено</option>
                  <option value="pending" data-id="element-12951">В обработке</option>
                  <option value="failed" data-id="element-12952">Ошибка</option>
                </select>
              </div>
              <div className="flex items-end" data-id="element-12953">
                <Button variant="ghost" fullWidth className="text-slate-500 hover:text-slate-900 bg-white border border-slate-200" onClick={() => {
              setFilterType('all');
              setFilterStatus('all');
              setSearchQuery('');
            }} data-id="element-12954">
                  Сбросить фильтры
                </Button>
              </div>
            </div>}
        </div>

        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-12955">
          <table className="w-full text-left text-sm" data-id="element-12956">
            <thead className="bg-slate-50/50 text-slate-500 border-b border-slate-100" data-id="element-12957">
              <tr data-id="element-12958">
                <th className="px-6 py-4 font-semibold" data-id="element-12959">Дата</th>
                <th className="px-6 py-4 font-semibold" data-id="element-12960">Тип</th>
                <th className="px-6 py-4 font-semibold" data-id="element-12961">Описание</th>
                <th className="px-6 py-4 font-semibold" data-id="element-12962">Статус</th>
                <th className="px-6 py-4 font-semibold text-right" data-id="element-12963">Сумма</th>
                <th className="px-6 py-4 font-semibold w-10" data-id="element-12964"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-12965">
              {paginatedTransactions.length > 0 ? paginatedTransactions.map(tx => {
              const isExpanded = expandedTxId === tx.id;
              const config = getTypeConfig(tx.type);
              return <Fragment key={tx.id} data-id="element-12966">
                      <tr className={`hover:bg-slate-50/80 transition-colors cursor-pointer ${isExpanded ? 'bg-slate-50/80' : ''}`} onClick={() => setExpandedTxId(isExpanded ? null : tx.id)} data-id="element-12967">
                        <td className="px-6 py-4 text-slate-500 whitespace-nowrap" data-id="element-12968">
                          {formatDate(tx.date)}
                        </td>
                        <td className="px-6 py-4" data-id="element-12969">
                          <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-xs font-medium ${config.bg} ${config.color}`} data-id="element-12970">
                            {config.icon}
                            {config.label}
                          </div>
                        </td>
                        <td className="px-6 py-4 text-slate-900 font-medium" data-id="element-12971">
                          {tx.description}
                        </td>
                        <td className="px-6 py-4" data-id="element-12972">
                          {getStatusBadge(tx.status)}
                        </td>
                        <td className={`px-6 py-4 text-right font-bold whitespace-nowrap ${tx.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-12973">
                          {tx.amount > 0 ? '+' : ''}
                          {formatMoney(tx.amount)}
                        </td>
                        <td className="px-6 py-4 text-slate-400" data-id="element-12974">
                          {isExpanded ? <ChevronUp className="w-5 h-5" data-id="element-12975" /> : <ChevronDown className="w-5 h-5" data-id="element-12976" />}
                        </td>
                      </tr>

                      {/* Expanded Details Row */}
                      {isExpanded && <tr className="bg-slate-50/50 border-b border-slate-200" data-id="element-12977">
                          <td colSpan={6} className="px-6 py-4" data-id="element-12978">
                            <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm animate-in fade-in slide-in-from-top-2" data-id="element-12979">
                              <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-12980">
                                <div data-id="element-12981">
                                  <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12982">
                                    ID Транзакции
                                  </div>
                                  <div className="text-sm font-medium text-slate-900 font-mono" data-id="element-12983">
                                    {tx.id}
                                  </div>
                                </div>

                                {tx.orderId && <div data-id="element-12984">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12985">
                                      Заказ
                                    </div>
                                    <div className="text-sm font-medium text-indigo-600 hover:underline cursor-pointer" onClick={e => {
                            e.stopPropagation();
                            if (setActiveTab) setActiveTab('orders');else showToast(`Заказ ${tx.orderId}`);
                          }} data-id="element-12986">
                                      {tx.orderId}
                                    </div>
                                  </div>}

                                {tx.clientName && <div data-id="element-12987">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12988">
                                      Клиент
                                    </div>
                                    <div className="text-sm font-medium text-slate-900" data-id="element-12989">
                                      {tx.clientName}
                                    </div>
                                  </div>}

                                {tx.serviceName && <div data-id="element-12990">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-1" data-id="element-12991">
                                      Услуга
                                    </div>
                                    <div className="text-sm font-medium text-slate-900" data-id="element-12992">
                                      {tx.serviceName}
                                    </div>
                                  </div>}
                              </div>

                              {/* Commission Breakdown for Income */}
                              {tx.type === 'income' && tx.commissionAmount !== undefined && tx.netAmount !== undefined && <div className="mt-6 pt-4 border-t border-slate-100" data-id="element-12993">
                                    <div className="text-xs text-slate-500 uppercase tracking-wider font-bold mb-3" data-id="element-12994">
                                      Расчет выплаты
                                    </div>
                                    <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 bg-slate-50 p-4 rounded-lg border border-slate-100" data-id="element-12995">
                                      <div data-id="element-12996">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-12997">
                                          Сумма заказа
                                        </div>
                                        <div className="font-medium text-slate-900" data-id="element-12998">
                                          {formatMoney(tx.amount)}
                                        </div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-slate-300" data-id="element-12999">
                                        -
                                      </div>
                                      <div data-id="element-13000">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-13001">
                                          Комиссия платформы (
                                          {tx.commissionPercent}%)
                                        </div>
                                        <div className="font-medium text-rose-600" data-id="element-13002">
                                          -{formatMoney(tx.commissionAmount)}
                                        </div>
                                      </div>
                                      <div className="hidden sm:flex items-center text-slate-300" data-id="element-13003">
                                        =
                                      </div>
                                      <div data-id="element-13004">
                                        <div className="text-xs text-slate-500 mb-1" data-id="element-13005">
                                          Вы получаете на руки
                                        </div>
                                        <div className="font-bold text-emerald-600 text-lg" data-id="element-13006">
                                          {formatMoney(tx.netAmount)}
                                        </div>
                                      </div>
                                    </div>
                                  </div>}
                            </div>
                          </td>
                        </tr>}
                    </Fragment>;
            }) : <tr data-id="element-13007">
                  <td colSpan={6} className="px-6 py-12 text-center text-slate-500" data-id="element-13008">
                    <FileText className="w-12 h-12 text-slate-300 mx-auto mb-3" data-id="element-13009" />
                    <div className="text-lg font-medium text-slate-900 mb-1" data-id="element-13010">
                      Транзакции не найдены
                    </div>
                    <p data-id="element-13011">Попробуйте изменить параметры фильтрации или поиска</p>
                  </td>
                </tr>}
            </tbody>
          </table>
        </div>

        {/* Mobile List */}
        <div className="md:hidden divide-y divide-slate-100" data-id="element-13012">
          {paginatedTransactions.length > 0 ? paginatedTransactions.map(tx => {
          const isExpanded = expandedTxId === tx.id;
          const config = getTypeConfig(tx.type);
          return <div key={tx.id} className="flex flex-col" data-id="element-13013">
                  {/* Mobile Card Header */}
                  <div className={`p-4 flex flex-col gap-3 cursor-pointer ${isExpanded ? 'bg-slate-50' : 'bg-white'}`} onClick={() => setExpandedTxId(isExpanded ? null : tx.id)} data-id="element-13014">
                    <div className="flex justify-between items-start" data-id="element-13015">
                      <div className="flex items-center gap-2" data-id="element-13016">
                        <div className={`p-1.5 rounded-md ${config.bg} ${config.color}`} data-id="element-13017">
                          {config.icon}
                        </div>
                        <div data-id="element-13018">
                          <div className="font-bold text-slate-900 text-sm" data-id="element-13019">
                            {tx.description}
                          </div>
                          <div className="text-xs text-slate-500 mt-0.5" data-id="element-13020">
                            {formatDate(tx.date)}
                          </div>
                        </div>
                      </div>
                      <div className="text-right" data-id="element-13021">
                        <div className={`font-bold ${tx.amount > 0 ? 'text-emerald-600' : 'text-slate-900'}`} data-id="element-13022">
                          {tx.amount > 0 ? '+' : ''}
                          {formatMoney(tx.amount)}
                        </div>
                        <div className="mt-1" data-id="element-13023">{getStatusBadge(tx.status)}</div>
                      </div>
                    </div>
                  </div>

                  {/* Mobile Expanded Details */}
                  {isExpanded && <div className="p-4 bg-slate-50 border-t border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-13024">
                      <div className="space-y-3" data-id="element-13025">
                        <div className="flex justify-between text-sm" data-id="element-13026">
                          <span className="text-slate-500" data-id="element-13027">ID Транзакции</span>
                          <span className="font-mono text-slate-900" data-id="element-13028">
                            {tx.id}
                          </span>
                        </div>

                        {tx.orderId && <div className="flex justify-between text-sm" data-id="element-13029">
                            <span className="text-slate-500" data-id="element-13030">Заказ</span>
                            <span className="font-medium text-indigo-600" onClick={e => {
                    e.stopPropagation();
                    if (setActiveTab) setActiveTab('orders');else showToast(`Заказ ${tx.orderId}`);
                  }} data-id="element-13031">
                              {tx.orderId}
                            </span>
                          </div>}

                        {tx.clientName && <div className="flex justify-between text-sm" data-id="element-13032">
                            <span className="text-slate-500" data-id="element-13033">Клиент</span>
                            <span className="font-medium text-slate-900" data-id="element-13034">
                              {tx.clientName}
                            </span>
                          </div>}

                        {/* Commission Breakdown for Mobile */}
                        {tx.type === 'income' && tx.commissionAmount !== undefined && tx.netAmount !== undefined && <div className="mt-4 pt-4 border-t border-slate-200 space-y-2" data-id="element-13035">
                              <div className="text-xs font-bold text-slate-500 uppercase mb-2" data-id="element-13036">
                                Расчет выплаты
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-13037">
                                <span className="text-slate-600" data-id="element-13038">
                                  Сумма заказа
                                </span>
                                <span className="font-medium text-slate-900" data-id="element-13039">
                                  {formatMoney(tx.amount)}
                                </span>
                              </div>
                              <div className="flex justify-between text-sm" data-id="element-13040">
                                <span className="text-slate-600" data-id="element-13041">
                                  Комиссия ({tx.commissionPercent}%)
                                </span>
                                <span className="font-medium text-rose-600" data-id="element-13042">
                                  -{formatMoney(tx.commissionAmount)}
                                </span>
                              </div>
                              <div className="flex justify-between text-base pt-2 border-t border-slate-200 mt-2" data-id="element-13043">
                                <span className="font-bold text-slate-900" data-id="element-13044">
                                  На руки
                                </span>
                                <span className="font-bold text-emerald-600" data-id="element-13045">
                                  {formatMoney(tx.netAmount)}
                                </span>
                              </div>
                            </div>}
                      </div>
                    </div>}
                </div>;
        }) : <div className="p-8 text-center text-slate-500" data-id="element-13046">
              <FileText className="w-10 h-10 text-slate-300 mx-auto mb-3" data-id="element-13047" />
              <div className="text-base font-medium text-slate-900 mb-1" data-id="element-13048">
                Транзакции не найдены
              </div>
            </div>}
        </div>

        {/* Pagination */}
        {totalPages > 1 && <div className="p-4 border-t border-slate-100 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-13049">
            <span className="text-xs text-slate-500" data-id="element-13050">
              Показано {(currentPage - 1) * ITEMS_PER_PAGE + 1}–
              {Math.min(currentPage * ITEMS_PER_PAGE, filteredTransactions.length)}{' '}
              из {filteredTransactions.length}
            </span>
            <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} data-id="element-13051" />
          </div>}
      </Card>

      {/* Withdraw Modal */}
      {showWithdrawModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13052">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13053">
            <div className="flex justify-between items-center p-5 border-b border-slate-100" data-id="element-13054">
              <h3 className="text-xl font-bold text-slate-900" data-id="element-13055">
                Вывод средств
              </h3>
              <button onClick={() => setShowWithdrawModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-13056">
                <X className="w-5 h-5" data-id="element-13057" />
              </button>
            </div>

            <div className="p-5 space-y-5" data-id="element-13058">
              {/* Amount Input */}
              <div data-id="element-13059">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13060">
                  Сумма вывода
                </label>
                <div className="relative" data-id="element-13061">
                  <input type="text" className="w-full pl-4 pr-12 py-3 text-2xl font-bold text-slate-900 bg-slate-50 border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="0" value={withdrawAmount} onChange={e => {
                const val = e.target.value.replace(/\D/g, '');
                setWithdrawAmount(val ? new Intl.NumberFormat('ru-RU').format(parseInt(val)) : '');
              }} data-id="element-13062" />
                  <span className="absolute right-4 top-1/2 -translate-y-1/2 text-xl font-bold text-slate-400" data-id="element-13063">
                    ₽
                  </span>
                </div>
                <div className="flex justify-between mt-2 text-sm" data-id="element-13064">
                  <span className="text-slate-500" data-id="element-13065">
                    Доступно:{' '}
                    <span className="font-bold text-slate-900" data-id="element-13066">
                      {formatMoney(availableToWithdraw)}
                    </span>
                  </span>
                  <button className="text-indigo-600 font-medium hover:underline" onClick={() => setWithdrawAmount(new Intl.NumberFormat('ru-RU').format(availableToWithdraw))} data-id="element-13067">
                    Вывести всё
                  </button>
                </div>
              </div>

              {/* Method Selector */}
              <div data-id="element-13068">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13069">
                  Куда перевести
                </label>
                <div className="space-y-2" data-id="element-13070">
                  {methods.map(method => <label key={method.id} className={`flex items-center justify-between p-3 rounded-xl border cursor-pointer transition-all ${selectedMethodId === method.id ? 'border-indigo-500 bg-indigo-50/30 ring-1 ring-indigo-500' : 'border-slate-200 hover:border-indigo-300'}`} data-id="element-13071">
                      <div className="flex items-center gap-3" data-id="element-13072">
                        <input type="radio" name="withdrawMethod" className="w-4 h-4 text-indigo-600 border-slate-300 focus:ring-indigo-500" checked={selectedMethodId === method.id} onChange={() => setSelectedMethodId(method.id)} data-id="element-13073" />
                        <div data-id="element-13074">
                          <div className="font-bold text-slate-900 text-sm" data-id="element-13075">
                            {method.details}
                          </div>
                          <div className="text-xs text-slate-500" data-id="element-13076">
                            {method.name}
                          </div>
                        </div>
                      </div>
                      <CreditCard className="w-5 h-5 text-slate-400" data-id="element-13077" />
                    </label>)}
                </div>
              </div>

              {/* Summary */}
              <div className="bg-slate-50 rounded-xl p-4 border border-slate-100 space-y-3" data-id="element-13078">
                <div className="flex justify-between text-sm" data-id="element-13079">
                  <span className="text-slate-500" data-id="element-13080">Комиссия за вывод</span>
                  <span className="font-medium text-slate-900" data-id="element-13081">0 ₽ (0%)</span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-13082">
                  <span className="text-slate-500" data-id="element-13083">Срок зачисления</span>
                  <span className="font-medium text-slate-900" data-id="element-13084">
                    1-3 рабочих дня
                  </span>
                </div>
                <div className="pt-3 border-t border-slate-200 flex justify-between items-center" data-id="element-13085">
                  <span className="font-bold text-slate-900" data-id="element-13086">
                    Итого к получению
                  </span>
                  <span className="text-xl font-bold text-emerald-600" data-id="element-13087">
                    {withdrawAmount ? formatMoney(parseInt(withdrawAmount.replace(/\D/g, ''))) : '0 ₽'}
                  </span>
                </div>
              </div>

              <Button variant="primary" size="lg" fullWidth onClick={handleWithdraw} data-id="element-13088">
                Подтвердить вывод
              </Button>
            </div>
          </div>
        </div>}

      {/* Top-up Modal */}
      {showTopupModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13089">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13090">
            {topupStep < 5 && <div className="h-1 bg-slate-100" data-id="element-13091">
                <div className="h-1 bg-emerald-500 transition-all duration-500" style={{
            width: `${(topupStep + 1) / 5 * 100}%`
          }} data-id="element-13092" />
              </div>}

            <div className="p-5 space-y-4" data-id="element-13093">
              {/* Step 0: Amount */}
              {topupStep === 0 && <>
                  <div className="flex items-center justify-between" data-id="element-13094">
                    <h3 className="text-lg font-bold text-slate-900" data-id="element-13095">
                      Пополнение баланса
                    </h3>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13096">
                      <X className="w-5 h-5" data-id="element-13097" />
                    </button>
                  </div>
                  <div className="grid grid-cols-2 gap-2" data-id="element-13098">
                    {TOPUP_AMOUNTS_ASTRO.map(amt => <button key={amt} onClick={() => {
                setTopupAmount(amt);
                setTopupCustom('');
              }} className={`py-3 px-3 rounded-xl text-sm font-bold transition-colors border ${topupAmount === amt ? 'bg-emerald-50 border-emerald-300 text-emerald-700' : 'bg-white border-slate-200 text-slate-700 hover:bg-slate-50'}`} data-id="element-13099">
                        {amt.toLocaleString('ru-RU')} ₽
                      </button>)}
                  </div>
                  <div className="relative" data-id="element-13100">
                    <input type="number" placeholder="Другая сумма" value={topupCustom} onChange={e => {
                setTopupCustom(e.target.value);
                setTopupAmount(null);
              }} className="w-full px-4 py-3 text-sm border border-slate-200 rounded-xl focus:outline-none focus:border-emerald-500" data-id="element-13101" />
                    <span className="absolute right-4 top-1/2 -translate-y-1/2 text-sm text-slate-400" data-id="element-13102">
                      ₽
                    </span>
                  </div>
                  <Button variant="primary" size="lg" fullWidth disabled={!topupFinalAmount || topupFinalAmount <= 0} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => setTopupStep(1)} data-id="element-13103">
                    Далее — способ оплаты
                  </Button>
                </>}

              {/* Step 1: Method */}
              {topupStep === 1 && <>
                  <div className="flex items-center justify-between" data-id="element-13104">
                    <div className="flex items-center gap-2" data-id="element-13105">
                      <button onClick={() => setTopupStep(0)} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13106">
                        <ArrowLeft className="w-5 h-5" data-id="element-13107" />
                      </button>
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-13108">
                        Способ оплаты
                      </h3>
                    </div>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13109">
                      <X className="w-5 h-5" data-id="element-13110" />
                    </button>
                  </div>
                  <div className="text-sm text-slate-500" data-id="element-13111">
                    Сумма:{' '}
                    <span className="font-bold text-slate-900" data-id="element-13112">
                      {topupFinalAmount.toLocaleString('ru-RU')} ₽
                    </span>
                  </div>
                  <div className="space-y-2" data-id="element-13113">
                    {TOPUP_METHODS.map(m => <button key={m.id} onClick={() => setTopupMethod(m.id)} className={`w-full flex items-center gap-3 p-3 rounded-xl border transition-colors text-left ${topupMethod === m.id ? 'border-emerald-300 bg-emerald-50' : 'border-slate-200 hover:bg-slate-50'}`} data-id="element-13114">
                        <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${topupMethod === m.id ? 'bg-emerald-100 text-emerald-600' : 'bg-slate-100 text-slate-500'}`} data-id="element-13115">
                          {m.icon}
                        </div>
                        <div data-id="element-13116">
                          <div className="text-sm font-bold text-slate-900" data-id="element-13117">
                            {m.label}
                          </div>
                          <div className="text-xs text-slate-500" data-id="element-13118">{m.desc}</div>
                        </div>
                        {topupMethod === m.id && <CheckCircle2 className="w-5 h-5 text-emerald-600 ml-auto shrink-0" data-id="element-13119" />}
                      </button>)}
                  </div>
                  <Button variant="primary" size="lg" fullWidth disabled={!topupMethod} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => {
              if (topupMethod === 'card') setTopupStep(2);else setTopupStep(3);
            }} data-id="element-13120">
                    Далее
                  </Button>
                </>}

              {/* Step 2: Card Details */}
              {topupStep === 2 && <>
                  <div className="flex items-center justify-between" data-id="element-13121">
                    <div className="flex items-center gap-2" data-id="element-13122">
                      <button onClick={() => setTopupStep(1)} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13123">
                        <ArrowLeft className="w-5 h-5" data-id="element-13124" />
                      </button>
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-13125">
                        Данные карты
                      </h3>
                    </div>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13126">
                      <X className="w-5 h-5" data-id="element-13127" />
                    </button>
                  </div>

                  <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-xl p-4 text-white space-y-3" data-id="element-13128">
                    <div className="flex justify-between items-start" data-id="element-13129">
                      <CreditCard className="w-8 h-8 text-slate-400" data-id="element-13130" />
                      <span className="text-xs text-slate-400 uppercase tracking-wider" data-id="element-13131">
                        {topupFinalAmount.toLocaleString('ru-RU')} ₽
                      </span>
                    </div>
                    <div className="text-lg font-mono tracking-widest" data-id="element-13132">
                      {topupCardNumber || '•••• •••• •••• ••••'}
                    </div>
                    <div className="flex justify-between text-xs text-slate-400" data-id="element-13133">
                      <span data-id="element-13134">{topupCardName || 'CARDHOLDER NAME'}</span>
                      <span data-id="element-13135">{topupCardExpiry || 'MM/YY'}</span>
                    </div>
                  </div>

                  <div className="space-y-3" data-id="element-13136">
                    <div data-id="element-13137">
                      <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13138">
                        Номер карты
                      </label>
                      <input type="text" value={topupCardNumber} placeholder="0000 0000 0000 0000" onChange={e => setTopupCardNumber(fmtCardNum(e.target.value))} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 font-mono tracking-wider" maxLength={19} data-id="element-13139" />
                    </div>
                    <div className="grid grid-cols-2 gap-3" data-id="element-13140">
                      <div data-id="element-13141">
                        <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13142">
                          Срок
                        </label>
                        <input type="text" value={topupCardExpiry} placeholder="MM/YY" onChange={e => setTopupCardExpiry(fmtExp(e.target.value))} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 font-mono" maxLength={5} data-id="element-13143" />
                      </div>
                      <div data-id="element-13144">
                        <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13145">
                          CVV
                        </label>
                        <input type="password" value={topupCardCvv} placeholder="•••" onChange={e => setTopupCardCvv(e.target.value.replace(/\D/g, '').slice(0, 4))} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 font-mono" maxLength={4} data-id="element-13146" />
                      </div>
                    </div>
                    <div data-id="element-13147">
                      <label className="text-xs text-slate-500 font-bold mb-1 block" data-id="element-13148">
                        Имя на карте
                      </label>
                      <input type="text" value={topupCardName} placeholder="IVAN IVANOV" onChange={e => setTopupCardName(e.target.value.toUpperCase())} className="w-full px-3 py-2.5 text-sm border border-slate-200 rounded-lg focus:outline-none focus:border-emerald-500 uppercase" data-id="element-13149" />
                    </div>
                    <label className="flex items-center gap-2 cursor-pointer" data-id="element-13150">
                      <input type="checkbox" checked={topupSaveCard} onChange={e => setTopupSaveCard(e.target.checked)} className="w-4 h-4 rounded border-slate-300 text-emerald-600 focus:ring-emerald-500" data-id="element-13151" />
                      <span className="text-xs text-slate-600" data-id="element-13152">
                        Сохранить карту
                      </span>
                    </label>
                  </div>

                  <div className="flex items-center gap-2 text-xs text-slate-400" data-id="element-13153">
                    <Shield className="w-3.5 h-3.5 shrink-0" data-id="element-13154" /> Данные защищены
                    SSL-шифрованием
                  </div>
                  <Button variant="primary" size="lg" fullWidth disabled={!isTopupCardValid} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => setTopupStep(3)} data-id="element-13155">
                    Оплатить {topupFinalAmount.toLocaleString('ru-RU')} ₽
                  </Button>
                </>}

              {/* Step 3: SMS */}
              {topupStep === 3 && <>
                  <div className="flex items-center justify-between" data-id="element-13156">
                    <div className="flex items-center gap-2" data-id="element-13157">
                      <button onClick={() => setTopupStep(topupMethod === 'card' ? 2 : 1)} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13158">
                        <ArrowLeft className="w-5 h-5" data-id="element-13159" />
                      </button>
                      <h3 className="text-lg font-bold text-slate-900" data-id="element-13160">
                        Подтверждение
                      </h3>
                    </div>
                    <button onClick={resetTopup} className="p-1 text-slate-400 hover:text-slate-600" data-id="element-13161">
                      <X className="w-5 h-5" data-id="element-13162" />
                    </button>
                  </div>

                  <div className="text-center py-3" data-id="element-13163">
                    <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto mb-3" data-id="element-13164">
                      <Smartphone className="w-7 h-7 text-emerald-600" data-id="element-13165" />
                    </div>
                    <p className="text-sm text-slate-700 font-medium" data-id="element-13166">
                      Введите код из СМС
                    </p>
                    <p className="text-xs text-slate-400 mt-0.5" data-id="element-13167">
                      Отправлен на +7 (•••) •••-••-42
                    </p>
                  </div>

                  <div className="flex justify-center gap-2" data-id="element-13168">
                    {[0, 1, 2, 3].map(i => <input key={i} type="text" maxLength={1} value={topupSmsCode[i] || ''} onChange={e => {
                const digit = e.target.value.replace(/\D/g, '');
                const arr = topupSmsCode.split('');
                arr[i] = digit;
                setTopupSmsCode(arr.join(''));
                if (digit && i < 3) {
                  const next = e.target.nextElementSibling as HTMLInputElement;
                  if (next) next.focus();
                }
              }} onKeyDown={e => {
                if (e.key === 'Backspace' && !topupSmsCode[i] && i > 0) {
                  const prev = (e.target as HTMLElement).previousElementSibling as HTMLInputElement;
                  if (prev) prev.focus();
                }
              }} className="w-12 h-14 text-center text-2xl font-bold border-2 border-slate-200 rounded-xl focus:outline-none focus:border-emerald-500 transition-colors" data-id="element-13169" />)}
                  </div>

                  <div className="text-center" data-id="element-13170">
                    {topupSmsTimer > 0 ? <span className="text-xs text-slate-400" data-id="element-13171">
                        Повторно через {topupSmsTimer} сек
                      </span> : <button onClick={() => {
                setTopupSmsTimer(60);
                showToast('Код отправлен повторно');
              }} className="text-xs text-emerald-600 hover:underline" data-id="element-13172">
                        Отправить повторно
                      </button>}
                  </div>

                  <Button variant="primary" size="lg" fullWidth disabled={topupSmsCode.replace(/\s/g, '').length < 4} className="bg-emerald-600 hover:bg-emerald-500" onClick={() => setTopupStep(4)} data-id="element-13173">
                    Подтвердить
                  </Button>
                </>}

              {/* Step 4: Processing */}
              {topupStep === 4 && <div className="text-center py-10" data-id="element-13174">
                  <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4" data-id="element-13175">
                    <Loader2 className="w-8 h-8 text-emerald-600 animate-spin" data-id="element-13176" />
                  </div>
                  <h4 className="font-bold text-slate-900" data-id="element-13177">
                    Обработка платежа...
                  </h4>
                  <p className="text-xs text-slate-400 mt-1" data-id="element-13178">
                    Не закрывайте окно
                  </p>
                  <div className="mt-4 flex justify-center gap-1" data-id="element-13179">
                    {[0, 1, 2].map(i => <div key={i} className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" style={{
                animationDelay: `${i * 0.3}s`
              }} data-id="element-13180" />)}
                  </div>
                </div>}

              {/* Step 5: Success */}
              {topupStep === 5 && <>
                  <div className="text-center py-4" data-id="element-13181">
                    <div className="w-16 h-16 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-3" data-id="element-13182">
                      <Check className="w-8 h-8 text-emerald-600" data-id="element-13183" />
                    </div>
                    <h4 className="font-bold text-slate-900 text-lg" data-id="element-13184">
                      Баланс пополнен!
                    </h4>
                    <p className="text-sm text-slate-500 mt-0.5" data-id="element-13185">
                      +{topupFinalAmount.toLocaleString('ru-RU')} ₽
                    </p>
                  </div>

                  <div className="bg-slate-50 rounded-xl p-4 space-y-2 border border-slate-100" data-id="element-13186">
                    <div className="flex items-center gap-2 mb-2" data-id="element-13187">
                      <FileText className="w-4 h-4 text-slate-400" data-id="element-13188" />
                      <span className="text-sm font-bold text-slate-700" data-id="element-13189">
                        Чек
                      </span>
                    </div>
                    <div className="space-y-1.5" data-id="element-13190">
                      <div className="flex justify-between text-sm" data-id="element-13191">
                        <span className="text-slate-500" data-id="element-13192">Операция</span>
                        <span className="text-slate-900" data-id="element-13193">
                          Пополнение баланса
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13194">
                        <span className="text-slate-500" data-id="element-13195">Сумма</span>
                        <span className="text-slate-900 font-bold" data-id="element-13196">
                          {topupFinalAmount.toLocaleString('ru-RU')} ₽
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13197">
                        <span className="text-slate-500" data-id="element-13198">Способ</span>
                        <span className="text-slate-900" data-id="element-13199">
                          {TOPUP_METHODS.find(m => m.id === topupMethod)?.label || ''}
                          {topupMethod === 'card' && topupCardNumber ? ` •••• ${topupCardNumber.slice(-4)}` : ''}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13200">
                        <span className="text-slate-500" data-id="element-13201">Дата</span>
                        <span className="text-slate-900" data-id="element-13202">
                          {new Date().toLocaleString('ru-RU', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                        </span>
                      </div>
                      <div className="flex justify-between text-sm" data-id="element-13203">
                        <span className="text-slate-500" data-id="element-13204">Статус</span>
                        <Badge variant="success" size="sm" data-id="element-13205">
                          <CheckCircle2 className="w-3 h-3 mr-0.5" data-id="element-13206" /> Успешно
                        </Badge>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-2" data-id="element-13207">
                    <Button variant="outline" size="lg" className="flex-1" onClick={() => showToast('Чек отправлен на email')} data-id="element-13208">
                      <Receipt className="w-4 h-4 mr-1" data-id="element-13209" /> Чек на email
                    </Button>
                    <Button variant="primary" size="lg" className="flex-1 bg-emerald-600 hover:bg-emerald-500" onClick={resetTopup} data-id="element-13210">
                      Готово
                    </Button>
                  </div>
                </>}
            </div>
          </div>
        </div>}

      {/* Download Modal */}
      {showDownloadModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-in fade-in duration-200" data-id="element-13211">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm overflow-hidden animate-in zoom-in-95 duration-200" data-id="element-13212">
            <div className="flex justify-between items-center p-5 border-b border-slate-100" data-id="element-13213">
              <h3 className="text-lg font-bold text-slate-900" data-id="element-13214">
                Скачать выписку
              </h3>
              <button onClick={() => setShowDownloadModal(false)} className="text-slate-400 hover:text-slate-600" data-id="element-13215">
                <X className="w-5 h-5" data-id="element-13216" />
              </button>
            </div>

            <div className="p-5 space-y-4" data-id="element-13217">
              <div data-id="element-13218">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13219">
                  Период
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={downloadPeriod} onChange={e => setDownloadPeriod(e.target.value)} data-id="element-13220">
                  <option value="week" data-id="element-13221">За неделю</option>
                  <option value="month" data-id="element-13222">За месяц</option>
                  <option value="quarter" data-id="element-13223">За квартал</option>
                  <option value="year" data-id="element-13224">За год</option>
                  <option value="all" data-id="element-13225">За всё время</option>
                </select>
              </div>

              <div data-id="element-13226">
                <label className="block text-sm font-bold text-slate-700 mb-2" data-id="element-13227">
                  Тип операций
                </label>
                <select className="w-full px-3 py-2 bg-white border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" value={downloadType} onChange={e => setDownloadType(e.target.value)} data-id="element-13228">
                  <option value="all" data-id="element-13229">Все операции</option>
                  <option value="income" data-id="element-13230">Только доходы</option>
                  <option value="withdrawal" data-id="element-13231">Только выводы</option>
                </select>
              </div>

              <div className="pt-2" data-id="element-13232">
                <Button variant="primary" fullWidth icon={<Download className="w-4 h-4" data-id="element-13234" />} onClick={handleDownload} data-id="element-13233">
                  Скачать CSV
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}